<div class="ui-fluid mb-3">
  <label [ngClass]="{'required': required}" *ngIf="label">{{ label }}</label><br />
  <ng-select [id]="_identifier" [(ngModel)]="_value" (ngModelChange)="_ngModelChanged($event)"
             (change)="_itemChanged($event)" bindLabel="nomeExibicao" bindValue="id" #model="ngModel" [items]="_kumites$ | async"
             [typeahead]="_kumiteInput$" [hideSelected]="true" typeToSearchText="{{ 'MENSAGEM_DIGITEPARABUSCAR' | translate }}"
             [ngClass]="{ 'is-invalid': form && (form.submitted || form.controls[name]?.touched || form.controls[name]?.dirty) && form.controls[name]?.errors}"
             notFoundText="{{ 'MENSAGEM_NAOENCONTRADO' | translate }}" [disabled]="disabled" [required]="required"
             [loading]="_loading">
    <ng-template ng-option-tmp let-item="item">
      <small>{{ item.situacaoEnum?.name }}</small>
      <br />
      <small>{{ item.numeroBasico }} - {{item.regionalNome}}</small>
      <div>{{ item.nomeExibicao }}</div>
      <small>{{ item.nomeJapones }}</small>

    </ng-template>
    <ng-template ng-footer-tmp>
      <small style="color: #007ad9">{{ 'LABEL_RODAPE' | translate }}</small>
    </ng-template>
  </ng-select>
  <validation-errors [form]="form" [controlName]="name"></validation-errors>
</div>
